"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNumeric = void 0;
function isNumeric(val) {
  return !isNaN(Number(val));
}
exports.isNumeric = isNumeric;